define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var TemplateGalleryItem = require("ui/gallery/templates/galleryItem.tmpl");
    var TemplateGalleryAddItem = require("ui/gallery/templates/galleryAddItem.tmpl");
    var Button = require("ui/button/Button");
    var Ellipsis = require("ui.plugins/ellipsis");
    var Translator = require("i18n/translator");
    var _ = require("underscore");
    var $ = require("jquery");

    var SELECTED_CSS_CLASS = "selected";
    var NOT_SELECTABLE_CLASS = "not-selectable-item";

    var GalleryItemView = Marionette.ItemView.extend({
        tagName: "li",
        className: "gallery-item",
        withUIComponents: true,
        ui:{
            button: ".gallery-item-button",
            name: ".name",
            nameContent: ".name .content",
            detailsButton: ".details-button",
            defaultIndicator: ".default"
        },
        // we are using events instead of triggers because triggers object use e.stopPropagation and we cannot use it here since other views can listen to the click
        events: {
            "click .gallery-item-button": "onItemClick",
            "mouseenter .gallery-item-button": "_onMouseEnter",
            "mouseleave .gallery-item-button": "_onMouseLeave"
        },

        modelEvents: {
            "change:name":"render",
            "change:description":"render"
        },

        customTemplateHelpers: function() {
            return {
                areNameAndDescShown: (this.selectedPermutation !== this.galleryPermutations.A),
                isDetailsButton: this.model.isEditable() || this.model.isViewable(),
                isUserDefault: this.model.isUserDefault(),
                isApiBased: this.model.isApiBased(),
                isTimezoneBased: this.model.isTimezoneBased()
            };
        },

        initialize:function(options){
            this.buttonEventTriggered = false;
            this.isSelectedItem = false;

            this.galleryPermutations = options.galleryPermutations;
            this.selectedPermutation = options.selectedPermutation;

            if (!this.model.isRegularType()) {
                this.template = TemplateGalleryAddItem;
            }
            else {
                this.template = TemplateGalleryItem;
            }
        },

        onRender: function() {
            if (this.model.isEditable() || this.model.isViewable()) {
                var isEditable = this.model.isEditable();
                this.uiComponents.host$.createAndRender("detailsButton", {
                    type: Button, // Component type to be instantiated
                    options: {                                       // Component initialization options
                        permutation : Button.PERMUTATION.BLUELINK,
                        text: Translator.translate(isEditable ? "LEUIComponents.global.edit":"LEUIComponents.global.view"),
                        el: "view.ui.detailsButton"
                    },
                    events: {                                        // Events that should be dispatched and propagated from the component to the parent view
                        click: isEditable? "onEditClick":"onViewClick"
                    }
                });
                this.ui.button.toggleClass(NOT_SELECTABLE_CLASS, !this.model.isSelectable());
            }
            this._setSelectedOnDom(this.isSelectedItem);
        },

        onClose: function() {
        },
        setSelected: function(state) {
            this.isSelectedItem = state;
            this._setSelectedOnDom(state);
        },

        _setSelectedOnDom: function(state) {
            this.ui.button.toggleClass(SELECTED_CSS_CLASS, state);
        },

        onItemClick: function() {
            // since edit is an internal DOM element to the Gallery item, we assume that the Edit Event is triggered prior to the Click Event
            // we don't actually mean to trigger click event on edit event (both triggered) so AS A WORKAROUND we act on click only if no edit event fired prior to it.
            if (!this.buttonEventTriggered && this.model.isSelectable()) {
                this.trigger("itemClick", this);
            } else {
                this.buttonEventTriggered = false;
            }
        },

        onEditClick: function() {
            this.buttonEventTriggered = true;
            this.trigger("editClick", this);
        },
        onViewClick: function() {
            this.buttonEventTriggered = true;
            this.trigger("viewClick", this);
        },

        _onMouseEnter: function() {
            this._handleEllipsis(true);
        },

        _onMouseLeave: function() {
            this._handleEllipsis(false);
        },

        _isJqueryInstance: function(obj){
            return obj instanceof $;
        },

        _handleEllipsis: function(isSetWidth) {

            // Ignore hover over an item without the edit button (In case of predefined gallery items - such as "All Visitors" target audience)
            if (this.ui.detailsButton.length > 0) {
                _.defer(_.bind(function(){
                    if (this._isJqueryInstance(this.ui.name) && this._isJqueryInstance(this.ui.detailsButton) && this._isJqueryInstance(this.ui.nameContent)) {//LE-80554
                        var maxWidth;

                        // Browser (IE) might not know to break a single long word - we need to force width on hover for having space for the "Edit" link
                        if (this.ui.name.length > 0) {
                            maxWidth = this.ui.name[0].clientWidth - this.ui.detailsButton[0].clientWidth;
                        }
                        Ellipsis.adjustWidth(this.ui.nameContent, maxWidth, isSetWidth);

                        Ellipsis.handleHover(this);
                    }
                }, this));
            }
        }
    });

    return GalleryItemView;
});
